export default __webpack_public_path__ + "static/media/icon-close.021397c2.svg";